import React, { Component } from "react";
import { buildData, buildOptions } from "./ChartUtils";
import { Chart } from "chart.js";
import { ContactSupportOutlined } from "@material-ui/icons";

class GraphWrapper extends Component {
  componentDidMount() {
    const ctx = this.refs.chart.getContext("2d");
    const { theme, start, end, data, emsName } = this.props;

    this.chart = new Chart(this.refs.chart, {
      type: "line",
      data: buildData(theme, ctx, data, emsName),
      options: buildOptions(theme, start, end),
    });
  }

  componentDidUpdate(prevProps, prevState) {
    let { data } = this.props;

    if (
      prevProps.start !== this.props.start ||
      prevProps.end !== this.props.end
    ) {
      this.chart.options.scales.xAxes[0].time.min = this.props.start;
      this.chart.options.scales.xAxes[0].time.max = this.props.end;
      this.chart.data.datasets[0].data = data;

      this.chart.update();
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  render() {
    return <canvas ref="chart"></canvas>;
  }
}

export default GraphWrapper;
